import { render, staticRenderFns } from "./NewsPage.vue?vue&type=template&id=30e7a1e1"
import script from "./NewsPage.vue?vue&type=script&lang=js"
export * from "./NewsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports